import { createApp } from 'vue'
import App from './App.vue'
import './assets/styles/tailwind.css'

createApp(App).mount('#app')
